import type { GetOversightImpactRatingByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetImpactOversightRatingByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactOversightRatingByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactOversightRatingByIdArgs = {
  id: string;
};

export const useGetImpactOversightRatingById = createQueryHook<
  UseGetImpactOversightRatingByIdArgs,
  GetOversightImpactRatingByIdResponseRow[],
  GetImpactOversightRatingByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impactRating.oversightImpactRatingById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ impact_oversight_rating: data }),
  graphqlDocument: GetImpactOversightRatingByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
